import { getDocument, useDocument } from "hooks/firestore/core/useDocument"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { getBroadcastRef } from "hooks/firestore/getRefs"
import { useShopId } from "hooks/localstate/context/useShopId"
import { Broadcast } from "types/firestore/broadcast"

// ts-prune-ignore-next
export function useBroadcast(broadcastId: undefined): undefined
export function useBroadcast(broadcastId: string | undefined): WithRef<Broadcast> | undefined
export function useBroadcast(broadcastId: string | undefined, shopId: string): WithRef<Broadcast> | undefined
export function useBroadcast(broadcastId: string | undefined, shopId?: string) {
  // TypeScript function overloads should prevent conditional calling of the hook
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const realShopId = shopId || useShopId()
  const { document } = useDocument(getBroadcastRef(realShopId, broadcastId))
  return document
}

// ts-prune-ignore-next
export async function getBroadcast(broadcastId: string, shopId: string) {
  return await getDocument(getBroadcastRef(shopId, broadcastId))
}
